import request from "@/utils/request";

export default function agentGetChildAgentListByPage(params, pageNum = 1, size = 10) {
    return request({
        url: `/user/agent/agentGetChildAgentListByPage/${pageNum}/${size}`,
        params
    })
}
